import React, { useEffect, useMemo, useState } from 'react';

import { useRequestContext } from '@lyearn/lygo-core';
import { Uppy } from '@lyearn/shared/hooks/useUppy';
import UppyContext from '@lyearn/shared/hooks/useUppy/UppyContext';

import VideoComponent from './NodeView';

const getUppyLib = async () => {
  const getUppyInstance = await import('./getUppyInstance');

  return { uppyInstance: getUppyInstance };
};

export const useUppyLazyGetInstance = () => {
  const [uppy, setUppy] = useState<{ Uppy: Uppy | null; loading?: boolean }>({ Uppy: null });

  useEffect(() => {
    const getWrapper = async () => {
      setUppy(() => ({ Uppy: null, loading: true }));
      const res = await getUppyLib();
      setUppy(() => ({ Uppy: res.uppyInstance.default(), loading: false }));
    };

    getWrapper();
  }, []);

  return { Uppy: uppy };
};

const UppyVideoWrapper: React.FC = () => {
  const { Uppy: value } = useUppyLazyGetInstance();

  const { enabledConvertibleImport } = useRequestContext();

  if (!enabledConvertibleImport || !value.Uppy) {
    return <VideoComponent />;
  }

  return (
    <UppyContext.Provider value={value}>
      <VideoComponent />
    </UppyContext.Provider>
  );
};

export default UppyVideoWrapper;
